import React from 'react';
import { AlertCircle, ArrowUp, ArrowDown, Minus } from 'lucide-react';

export type TicketPriority = 'low' | 'normal' | 'high' | 'urgent';

interface PriorityBadgeProps {
  priority: TicketPriority;
  size?: 'sm' | 'md' | 'lg';
}

export function PriorityBadge({ priority, size = 'md' }: PriorityBadgeProps) {
  const config: Record<TicketPriority, { label: string; icon: typeof AlertCircle; className: string; iconClassName: string }> = {
    urgent: {
      label: 'Urgent',
      icon: AlertCircle,
      className: 'bg-red-50 text-red-700 ring-1 ring-inset ring-red-600/10',
      iconClassName: 'text-red-600'
    },
    high: {
      label: 'High',
      icon: ArrowUp,
      className: 'bg-orange-50 text-orange-700 ring-1 ring-inset ring-orange-600/10',
      iconClassName: 'text-orange-600'
    },
    normal: {
      label: 'Normal',
      icon: Minus,
      className: 'bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-600/10',
      iconClassName: 'text-blue-500'
    },
    low: {
      label: 'Low',
      icon: ArrowDown,
      className: 'bg-gray-50 text-gray-600 ring-1 ring-inset ring-gray-500/10',
      iconClassName: 'text-gray-400'
    }
  };

  const priorityConfig = config[priority] || config.normal;
  const { label, icon: Icon, className, iconClassName } = priorityConfig;

  const sizeClasses = {
    sm: 'px-1.5 py-0.5 text-[10px]',
    md: 'px-2 py-0.5 text-xs',
    lg: 'px-2.5 py-1 text-sm'
  };

  const iconSizes = {
    sm: 10,
    md: 12,
    lg: 14
  };

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md font-medium ${className} ${sizeClasses[size]}`}
    >
      <Icon size={iconSizes[size]} className={iconClassName} />
      {label}
    </span>
  );
}
